import templatesComponent from './templates.component';
import templatesRoute from './templates.routes';

angular.module('rym.templates', []).component('rymTemplates', templatesComponent).run(templatesRoute);
